export const SONGS_SEQUENCE_SET_SELECTED = 'SONGS_SEQUENCE_SET_SELECTED';
export const SONGS_SEQUENCE_CHANGE_ORDER = 'SONGS_SEQUENCE_CHANGE_ORDER';
export const SONGS_SEQUENCE_CLEAR = 'SONGS_SEQUENCE_CLEAR';
export const PLAYLIST_SAVE_START = 'PLAYLIST_SAVE_START';
export const PLAYLIST_SAVE_SUCCESS = 'PLAYLIST_SAVE_SUCCESS';
export const PLAYLIST_SAVE_ERROR = 'PLAYLIST_SAVE_ERROR';
export const PLAYLIST_SAVE_HIDE_ERROR = 'PLAYLIST_SAVE_HIDE_ERROR';
